import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Plus, AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { eur } from "@/components/excelVoce/format";
import { ContrattoDialog } from "./ContrattoDialog";
import { ContrattoPanel } from "./ContrattoPanel";
import { FunzioniSpente, isAdmin, useFunzioniExcel } from "./labels";

export const SalE5Tab = ({ computoId }) => {
  const { user } = useAuth();
  const fx = useFunzioniExcel();
  const [data, setData] = useState(null);
  const [sel, setSel] = useState(null);
  const [nuovo, setNuovo] = useState(false);
  const [mis, setMis] = useState(null);
  const load = () => {
    api.get(`/computi/${computoId}/misure/riepilogo`).then((r) => setMis(r.data));
    return api.get(`/computi/${computoId}/sal-contratti`).then((r) => {
    setData(r.data);
    setSel((s) => (r.data.contratti.some((k) => k.id === s) ? s : r.data.contratti[0]?.id || null));
  });
  };
  useEffect(() => { load(); }, [computoId]);
  if (!data) return <p className="text-sm text-slate-500 p-4">Caricamento…</p>;
  return (
    <div className="space-y-4" data-testid="sal-e5-tab">
      <Card><CardContent className="p-4 sm:p-6 space-y-4">
        <div className="flex flex-wrap items-start gap-3">
          <div className="mr-auto max-w-2xl">
            <div className="text-xs uppercase tracking-widest text-sky-700 font-semibold">SAL del computo Excel</div>
            <p className="text-xs text-slate-500 mt-1">Si contabilizzano solo le quantità misurate e verificate dal tecnico nel libretto delle misure di ogni voce, anche senza registrazioni di costo. Il SAL generale usa i prezzi del computo e comprende anche i subappaltatori; il SAL di ogni subappaltatore solo le sue misure, ai suoi prezzi concordati. Ore, consegne e costi del Registro effettivo non diventano quantità.</p>
          </div>
          {isAdmin(user) && <Button size="sm" onClick={() => setNuovo(true)} data-testid="sal-nuovo-contratto"><Plus className="h-3.5 w-3.5 mr-1" /> Rapporto contrattuale</Button>}
        </div>
        <FunzioniSpente st={fx} />
        {mis && <p className="text-xs text-slate-600" data-testid="sal-misure-riepilogo">Libretto delle misure: {mis.totale} misure · {mis.verificate} verificate · <span className={mis.da_verificare ? "text-amber-700 font-semibold" : ""}>{mis.da_verificare} da verificare</span></p>}
        {data.rilievi_legacy > 0 && <p className="text-xs text-amber-700 flex items-center gap-1" data-testid="sal-rilievi-legacy"><AlertTriangle className="h-3.5 w-3.5" /> {data.rilievi_legacy} rilievi storici su questo computo sono fuori dal libretto delle misure e non sono contabilizzati.</p>}
        {data.contratti.length === 0 ? <p className="text-sm text-slate-500" data-testid="sal-nessun-contratto">Nessun rapporto contrattuale. {isAdmin(user) ? "Crea il SAL generale o quello di un subappaltatore." : "L'amministratore deve crearlo."}</p> : (
          <div className="flex flex-wrap gap-2" data-testid="sal-contratti-lista">
            {data.contratti.map((k) => (
              <button key={k.id} type="button" onClick={() => setSel(k.id)} data-testid={`sal-contratto-${k.id}`}
                className={`text-left rounded-md border px-3 py-2 transition-colors ${sel === k.id ? "border-sky-500 bg-sky-50" : "hover:bg-slate-50"}`}>
                <div className="text-sm font-medium">{k.nome}</div>
                <div className="text-[11px] text-slate-500">{k.riepilogo.n_emessi} SAL emessi · contabilizzato {eur(k.riepilogo.contabilizzato)}{k.riepilogo.n_bozze ? ` · ${k.riepilogo.n_bozze} in lavorazione` : ""}</div>
              </button>
            ))}
          </div>
        )}
      </CardContent></Card>
      {sel && <ContrattoPanel key={sel} kid={sel} onChanged={load} />}
      {nuovo && <ContrattoDialog computoId={computoId} onClose={() => setNuovo(false)} onSaved={(k) => { setNuovo(false); setSel(k.id); load(); }} />}
    </div>
  );
};
